var _defs, _path, _rect, _rect2, _rect3, _rect4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmpresaIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-5d5eebd1-c270-4a02-b221-5fa0c021b930",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1080 1079.96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "uuid-fdf32948-772b-4a7e-886a-8f520b6476e4",
    d: "M1035.21,495.14h-450.44V44.79c0-24.76-20.03-44.79-44.79-44.79H44.79C20.08,0,0,20.03,0,44.79v990.38c0,24.76,20.08,44.79,44.79,44.79h990.42c24.71,0,44.79-20.03,44.79-44.79v-495.23c0-24.76-20.08-44.79-44.79-44.79ZM154.49,990.38h-64.91v-60.27h64.91v60.27ZM154.49,840.52h-64.91v-83.11h64.91v83.11ZM154.49,667.83h-64.91v-83.11h64.91v83.11ZM154.49,495.14h-64.91v-83.11h64.91v83.11ZM154.49,322.46h-64.91v-83.02h64.91v83.02ZM154.49,149.86h-64.91v-60.27h64.91v60.27ZM324.86,990.38h-80.79v-60.27h80.79v60.27ZM324.86,840.52h-80.79v-83.11h80.79v83.11ZM324.86,667.83h-80.79v-83.11h80.79v83.11ZM324.86,495.14h-80.79v-83.11h80.79v83.11ZM324.86,322.46h-80.79v-83.02h80.79v83.02ZM324.86,149.86h-80.79v-60.27h80.79v60.27ZM495.19,990.38h-80.75v-60.27h80.75v60.27ZM495.19,840.52h-80.75v-83.11h80.75v83.11ZM495.19,667.83h-80.75v-83.11h80.75v83.11ZM495.19,495.14h-80.75v-83.11h80.75v83.11ZM495.19,322.46h-80.75v-83.02h80.75v83.02ZM495.19,149.86h-80.75v-60.27h80.75v60.27ZM990.42,990.38h-405.65v-405.65h405.65v405.65Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "uuid-fdf32948-772b-4a7e-886a-8f520b6476e4",
    x: 650.2,
    y: 645.22,
    width: 104.1,
    height: 104.1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "uuid-fdf32948-772b-4a7e-886a-8f520b6476e4",
    x: 820.88,
    y: 645.22,
    width: 104.1,
    height: 104.1
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "uuid-fdf32948-772b-4a7e-886a-8f520b6476e4",
    x: 650.2,
    y: 823.68,
    width: 104.1,
    height: 104.1
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "uuid-fdf32948-772b-4a7e-886a-8f520b6476e4",
    x: 820.88,
    y: 823.68,
    width: 104.1,
    height: 104.1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpresaIcon);
export default __webpack_public_path__ + "static/media/EmpresaIcon.9017727b683e74a8f0049126607b942e.svg";
export { ForwardRef as ReactComponent };